import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialOutstoreApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialOutstore'
  }

}